import { Box, IconButton, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { ICON_XS } from '../common/theme'
import { STATE_DEFS } from '../common/constants'
import StatePill from './StatePill'

interface StateDisplayProps {
  questions: any[]
  stateFilter?: string
  onStateClick?: (state: string) => void
  onClearFilter?: () => void
}

// Row of StatePills with counts per state. Optional click-to-filter and a
// clear button. Pills for states with zero questions are hidden.
export default function StateDisplay({ questions, stateFilter, onStateClick, onClearFilter }: StateDisplayProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
      {stateFilter && onClearFilter && (
        <Tooltip title="Clear filter">
          <IconButton size="small" onClick={onClearFilter} sx={{ p: 0.25 }}>
            <CloseIcon sx={{ fontSize: ICON_XS }} />
          </IconButton>
        </Tooltip>
      )}
      {STATE_DEFS.map(({ key }) => {
        const count = questions.filter(q => q.state === key).length
        if (count === 0) return null
        const dimmed = !!stateFilter && stateFilter !== key
        return (
          <Box
            key={key}
            onClick={onStateClick ? () => onStateClick(key) : undefined}
            sx={{
              display: 'inline-flex',
              cursor: onStateClick ? 'pointer' : 'default',
              opacity: dimmed ? 0.35 : 1,
              transition: 'opacity 0.15s',
            }}
          >
            <StatePill state={key} count={count} />
          </Box>
        )
      })}
    </Box>
  )
}
